import utils from '../utils';

export default function oneOfValue(values, paramName) {
    return (value) => {
        const message = 'Supported ' + paramName + ' is expected (one of: ' + values + '), but ' + value +
            ' [' + typeof value + '] was given.';
        return utils.validateAgainstSetOfValues(value, values, message);
    };
}
